import { useQuery } from 'data-fetching-client';
import * as TierGroups from 'marketplace-ui-common/constants/groupTags/TierGroups';
import { GET_COMPATIBILITY } from 'marketplace-ui-common/compatibility/queries/compatibilityQuery';
let _flattenedTierOrder;
const getFlattenedTierOrder = () => {
  if (!_flattenedTierOrder) {
    _flattenedTierOrder = [TierGroups.CRM, TierGroups.MARKETING, TierGroups.SALES, TierGroups.SERVICE, TierGroups.CONTENT, TierGroups.OPERATIONS].reduce( /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    (acc, val) => acc.concat(val), []);
  }
  return _flattenedTierOrder;
};
/**
 * @deprecated only for use with deprecated integrationFeatures
 */
const useRequiredPlansForIntegrationFeatures = ({
  appContext,
  integrationFeatures = []
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_COMPATIBILITY, {
    variables: {
      appContext,
      offeringType: 'APP'
    }
  });
  const {
    compatibility,
    portalTiers
  } = data && data.compatibility || {
    compatibility: {},
    portalTiers: []
  };
  const minimumRequiredPlans = integrationFeatures.map(integrationFeature => {
    if (!integrationFeature.hubSpotFeatures || !data) {
      return '';
    }
    const flattenedTierOrder = getFlattenedTierOrder();
    return integrationFeature.hubSpotFeatures.reduce((minPlan, hubSpotFeature) => {
      const requiredTiers = compatibility[hubSpotFeature].filter(tier => {
        return flattenedTierOrder.includes(tier);
      }) || [];
      if (!(requiredTiers !== null && requiredTiers !== void 0 && requiredTiers.length) || !!(portalTiers !== null && portalTiers !== void 0 && portalTiers.filter(tier => requiredTiers.indexOf(tier) !== -1).length)) {
        // Current plan compatible with this feature
        return minPlan;
      }
      // Current plan incompatible, find lowest compatible plan
      return [...requiredTiers, ...(minPlan ? [minPlan] : [])].sort((tierA, tierB) => flattenedTierOrder.indexOf(tierA) - flattenedTierOrder.indexOf(tierB))[0];
    }, '');
  });
  return {
    requiredPlans: minimumRequiredPlans,
    compatibilityLoading: loading,
    compatibilityError: error
  };
};
export default useRequiredPlansForIntegrationFeatures;